import React from "react"
import styles from "./Label.module.css"

const Label = ({ children, required, id, className, hasError }) => {
  return (
    <label htmlFor={id} data-testid="label" className={`${styles.label} ${hasError ? styles.error : ""} ${className}`}>
      {children}
      {required && "*"}
    </label>
  )
}

Label.defaultProps = {
  className: "",
  hasError: false,
}

export default Label
